const {
  REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENTID,
  REACT_APP_AUTH0_ORGANIZATION_ID,
  REACT_APP_CA_SDK_URL,
  REACT_APP_CA_BACKEND_URL,
  REACT_APP_LOGS_URL,
  REACT_APP_MIXPANEL_KEY,
  REACT_APP_GENERIC_LOGIN_URL,
  REACT_APP_ENV_NAME,
  REACT_APP_GOOGLE_ANALYTICS,
  REACT_APP_STORAGE,
  REACT_APP_AUTH0_SCOPE_NAMESPACE,
  REACT_APP_OTB_ENABLED,
  REACT_APP_FEATURE_FLAGS_KEY,
  REACT_APP_FEATURE_FLAGS_BASE_URL,
} = process.env;

export const environment = {
  auth0Domain: REACT_APP_AUTH0_DOMAIN,
  auth0ClientId: REACT_APP_AUTH0_CLIENTID,
  auth0OrganizationId: REACT_APP_AUTH0_ORGANIZATION_ID,
  caSdkUrl: REACT_APP_CA_SDK_URL,
  backendBaseUrl: REACT_APP_CA_BACKEND_URL,
  logsUrl: REACT_APP_LOGS_URL,
  mixpanelKey: REACT_APP_MIXPANEL_KEY,
  genericLoginUrl: REACT_APP_GENERIC_LOGIN_URL,
  envName: REACT_APP_ENV_NAME,
  googleAnalyticsKey: REACT_APP_GOOGLE_ANALYTICS,
  storageUrl: REACT_APP_STORAGE,
  auth0ScopeNamespace: REACT_APP_AUTH0_SCOPE_NAMESPACE,
  otbEnabled: REACT_APP_OTB_ENABLED,
  featureFlagsKey: REACT_APP_FEATURE_FLAGS_KEY,
  featureFlagsBaseUrl: REACT_APP_FEATURE_FLAGS_BASE_URL,
};
